import { useUserStore } from '@/config/store/userStore'
import { isModuleActive } from '@/services/application'
import {
  hasAnyEvaluationSettingsAccess,
  hasEvaluationSettingAccess,
  type EvaluationSettingAccessKey,
} from '@/services/evaluation/settingsAccess'

const moduleId = 7

export const canUserAccessModule = (user) => {
  const isFirmAccess = isModuleActive(user.firm, moduleId)
  return isFirmAccess && user.profile.modules.evaluation?.isAccess
}

export const guardEvaluationAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = canUserAccessModule(user)
  return canAccess || { name: 'Home' }
}

export const guardCreation360 = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.create360
  return canAccess || { name: 'Home' }
}

export const guardCreationPeriod = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.createPeriod
  return canAccess || { name: 'Home' }
}

export const guardEditEvaluation = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.canEditEvaluation
  return canAccess || { name: 'Home' }
}

export const guardSettingsAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return hasAnyEvaluationSettingsAccess(user.profile.modules.evaluation) || { name: 'Home' }
}

export const guardEvaluationSettingAccess = (key: EvaluationSettingAccessKey) => {
  const userStore = useUserStore()
  const user = userStore.user
  return hasEvaluationSettingAccess(user.profile.modules.evaluation, key) || { name: 'Home' }
}

export const guardEvaluationFormsSettingsAccess = () => guardEvaluationSettingAccess('settingsEvaluationFormsAccess')
export const guardEvaluationAveragesSettingsAccess = () => guardEvaluationSettingAccess('settingsEvaluationAveragesAccess')

export const guardCreationProject = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.createProject
  return canAccess || { name: 'Home' }
}
export const guardCreationProjectSimplified = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.createProjectSimplified
  return canAccess || { name: 'Home' }
}

export const guardCreationEvaluation = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.create360 || user.profile.modules.evaluation?.createPeriod || user.profile.modules.evaluation?.createProject
  return canAccess || { name: 'Home' }
}

export const guardCampaign = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.accessCampaign
  return canAccess || { name: 'Home' }
}

export const guardSummaries = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.accessSummaries
  return canAccess || { name: 'Home' }
}

export const guardSummaryCreation = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = user.profile.modules.evaluation?.canCreateSummary
  return canAccess || { name: 'Home' }
}
